import React from 'react';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { loginPath } from '../../Utils/routes';

function SignUpButton({ size = 'medium' }) {
  return (
    <Button
      variant="contained"
      color="primary"
      size={size}
      data-testid="sign-up-button"
      component={Link}
      to={loginPath()}
    >
      <FormattedMessage id="SIGN_IN" />
    </Button>
  );
}

export default SignUpButton;
